// utils.ts
export interface Position {
  x: number;
  y: number;
}

const getRandomInt = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const generateWinningCombination = (
  boardSize: number,
  combinationSize: number,
): Position[] => {
  if (combinationSize > boardSize) {
    throw new Error('Combination size cannot be larger than board size.');
  }

  const directions = ['horizontal', 'vertical', 'diagonal'];
  const direction = directions[getRandomInt(0, directions.length - 1)];

  const positions: Position[] = [];

  switch (direction) {
    case 'horizontal': {
      const row = getRandomInt(0, boardSize - 1);
      const startCol = getRandomInt(0, boardSize - combinationSize);
      for (let i = 0; i < combinationSize; i++) {
        positions.push({ x: row, y: startCol + i });
      }
      break;
    }
    case 'vertical': {
      const col = getRandomInt(0, boardSize - 1);
      const startRow = getRandomInt(0, boardSize - combinationSize);
      for (let i = 0; i < combinationSize; i++) {
        positions.push({ x: startRow + i, y: col });
      }
      break;
    }
    case 'diagonal': {
      const isDiagonalDownRight = Math.random() < 0.5;
      if (isDiagonalDownRight) {
        const startRow = getRandomInt(0, boardSize - combinationSize);
        const startCol = getRandomInt(0, boardSize - combinationSize);
        for (let i = 0; i < combinationSize; i++) {
          positions.push({ x: startRow + i, y: startCol + i });
        }
      } else {
        const startRow = getRandomInt(combinationSize - 1, boardSize - 1);
        const startCol = getRandomInt(0, boardSize - combinationSize);
        for (let i = 0; i < combinationSize; i++) {
          positions.push({ x: startRow - i, y: startCol + i });
        }
      }
      break;
    }
  }

  return positions;
};
